import dayjs from 'dayjs';
import type { IntlShape } from 'react-intl';

export const getDateDifference = (
  startDate: string,
  endDate: string | null,
  intl: IntlShape
) => {
  const start = dayjs(startDate);
  const end = endDate === null ? dayjs() : dayjs(endDate);

  const years = end.diff(start, 'year');
  const months = end.diff(start, 'month') % 12;
  const days = end.diff(start, 'day') % 30;

  const parts: string[] = [];

  if (years > 0) {
    parts.push(
      intl.formatMessage({ id: 'commons.time.years' }, { count: years })
    );
  }

  if (months > 0) {
    parts.push(
      intl.formatMessage({ id: 'commons.time.months' }, { count: months })
    );
  }

  if (days > 0) {
    parts.push(
      intl.formatMessage({ id: 'commons.time.days' }, { count: days })
    );
  }

  return parts.join(' ');
};
